











import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Checkbox extends Vue {
  @Prop({ type: Boolean, default: () => false }) value: boolean;
  @Prop({ type: String, default: () => "" }) label: string;

  @Watch("value")
  onValueChanged(val, oldVal) {
    this.$emit("input", val);
  }
}
